import { payrunTypeItems } from '@xemplo/gp-types';
import { CenteredLoaderDots } from '@xemplo/loader';
import { useGetPayrunApproversDetailQuery } from '@xemplo/payrun-query';

import { TestIds } from '../payrun-approvers-detail.test-helper';

import * as S from './modal-styles';
import { payrunSchedulesColumns } from './payrun-approvers-detail.helper';
import { PayrunDetailApproverModalProps } from './payrun-approvers-detail-modal.types';

export const ModalBody = (props: Readonly<PayrunDetailApproverModalProps>) => {
  const { data, isLoading } = useGetPayrunApproversDetailQuery(props);

  if (isLoading) return <CenteredLoaderDots />;
  if (!data) return null;

  return (
    <S.Container>
      <S.Label>Details</S.Label>
      <S.Type>
        Payrun Type
        <S.TypeContent data-testid={TestIds.PayrunTypeId}>
          {payrunTypeItems.find((f) => f.key === data.payrunTypeId)?.value}
        </S.TypeContent>
      </S.Type>
      <S.Label>Pay Schedule(s)</S.Label>
      <S.PayScheduleTable
        data={data.payschedules}
        columns={payrunSchedulesColumns}
        enableRowSelection={false}
        enableTotals={false}
        manualPagination={false}
        enablePagination={true}
        totalRowCount={data.payschedules.length}
      />
    </S.Container>
  );
};
